import { render, staticRenderFns } from "./LoginAcesso.vue?vue&type=template&id=382f6f10&scoped=true"
import script from "./LoginAcesso.vue?vue&type=script&lang=js"
export * from "./LoginAcesso.vue?vue&type=script&lang=js"
import style0 from "./LoginAcesso.vue?vue&type=style&index=0&id=382f6f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f6f10",
  null
  
)

export default component.exports